module.exports = __webpack_public_path__ + "static/js-42db0f0d94150ef0ecf9d16033c3605a.jpg";